import { getValidValue } from "..//functions/helperMethod.js";

const IFS_USER_DETAILS_KEY = "ifsUserDetails";

/**
 * Read IFS login identity for User-Key segment 2 from persisted get-ifs-user payload.
 * Matches API shape e.g. UserEmail, WebUser, PreferredUsername (PascalCase).
 */
function readIfsUserSecondaryIdentity() {
  try {
    const raw = localStorage.getItem(IFS_USER_DETAILS_KEY);
    if (!raw) return "";
    const u = JSON.parse(raw);
    return getValidValue(
      u?.UserEmail ??
        u?.userEmail ??
        u?.WebUser ??
        u?.webUser ??
        u?.PreferredUsername ??
        u?.preferredUsername,
      ""
    );
  } catch {
    return "";
  }
}

export default class AuthTeams {
  constructor() {
    this.getUPN = this.getUPN.bind(this);
    this.getTeamsToken = this.getTeamsToken.bind(this);
    this.getEmail = this.getEmail.bind(this);
    this.getIfsUserCode = this.getIfsUserCode.bind(this);
    this.getIfsWebUser = this.getIfsWebUser.bind(this);
  }

  //localStorage ssoUserToken
  /**
   * Stores the provided access token in the browser's localStorage under the key "ssoUserToken".
   *
   * @param {string} accessToken - The Single Sign-On (SSO) user access token to be stored.
   */
  // setSSOUserToken(accessToken){
  //   localStorage.setItem("ssoUserToken", accessToken);
  // }

  // getSSOUserToken(){
  //   return localStorage.getItem("ssoUserToken");
  // }

  // removeSSOUserToken(){
  //   localStorage.removeItem("ssoUserToken");
  // }

  //end of localStorage ssoUserToken

  /**
   * Stores the user's email address in localStorage.
   *
   * @param {string} emailId - The email address to be stored.
   */
  setEmail(emailId) {
    localStorage.setItem("userEmail", emailId);
  }

  getEmail() {
    return getValidValue(localStorage.getItem("userEmail"), "");
  }

  getIfsUserCode() {
    return getValidValue(localStorage.getItem("ifsUserCode"), "");
  }
  
  getIfsWebUser() {
    return readIfsUserSecondaryIdentity();
  }

  removeEmail() {
    localStorage.removeItem("userEmail");
  }

  getUPN() {
    return localStorage.getItem("userPrincipalName");
  }

  getTeamsToken() {
    if (localStorage.getItem("ssoToken") === null) {
      return localStorage.getItem("msal.idtoken");
    }
    return localStorage.getItem("ssoToken");
  }

  getTenantId() {
    return localStorage.getItem("tenantId");
  }

  getUserId() {
    return localStorage.getItem("userId");
  }

  getClientId() {
    return localStorage.getItem("clientId");
  }

  getCustomerKey() {
    return localStorage.getItem("clientId");
  }

  getGroupId() {
    return localStorage.getItem("groupId");
  }

  getChannelId() {
    return localStorage.getItem("channelId");
  }

  getFolderName() {
    return localStorage.getItem("folderName");
  }

  redirectToLogin() {
    this.logout();
    window.location.href = "/";
  }

  /**
   * User-Key header value for service APIs: IFS auth code [, IFS user email]. No Azure UPN.
   * First segment is the OAuth `code` stored as `ifsUserCode` (backend memory-cache key).
   * After get-ifs-user, second segment is IFS `UserEmail` / `WebUser` from `ifsUserDetails`.
   * Before that, returns the code only — backend treats single-segment keys as code + placeholder.
   * @returns {string}
   */
  getUserKey() {
    const ifsAuthCode = getValidValue(localStorage.getItem("ifsUserCode"), "");
    const ifsIdentity = readIfsUserSecondaryIdentity();
    if (!ifsAuthCode) {
      return "";
    }
    if (ifsIdentity) {
      return `${ifsAuthCode},${ifsIdentity}`;
    }
    return ifsAuthCode;
  }
}
